import { render } from "./pageBtn.vue?vue&type=template&id=4757a116&ts=true"
import script from "./pageBtn.vue?vue&type=script&lang=ts"
export * from "./pageBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__